"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterLabelSpan = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const FooterLabelSpan = exports.FooterLabelSpan = /*#__PURE__*/(0, _base.default)("span", process.env.NODE_ENV === "production" ? {
  target: "edm5klv0"
} : {
  target: "edm5klv0",
  label: "FooterLabelSpan"
})(process.env.NODE_ENV === "production" ? {
  name: "qi2aoe",
  styles: "color:white;font-size:14px;font-weight:bold;text-transform:uppercase;margin-bottom:0.5em"
} : {
  name: "qi2aoe",
  styles: "color:white;font-size:14px;font-weight:bold;text-transform:uppercase;margin-bottom:0.5em",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});